import { Record } from "immutable";
import { phoneFromJSON, IPhoneNumberData, PhoneNumberRecord } from "common/records/PhoneNumber";
import { checkDate } from "common/helpers/Date";
import {
  INotificationsConfigData,
  IUserPrefConfigData,
  IUserPrefConfigRecord,
  userPrefConfigFromJSON,
} from "common/records/UserPreferenceConfig";
import { DateStringNumber } from ".";

export const userPreferenceFromJSON = (data: Partial<IUserPreferenceData>): UserPreferenceRecord => {
  const record: IUserPreferenceRecord = { ...(data as any) };

  if (data.config) {
    record.config = userPrefConfigFromJSON(data.config);
  }

  if (data.sms_number) {
    record.sms_number = phoneFromJSON(data.sms_number);
  }

  if (data.created_at) {
    record.created_at = checkDate(data.created_at);
  }

  if (data.updated_at) {
    record.updated_at = checkDate(data.updated_at);
  }

  return new UserPreferenceRecord(record);
};

export interface IUserPreferenceData {
  id: number;
  user_id: number;
  estimator_tour: boolean;
  created_at: DateStringNumber;
  updated_at: DateStringNumber;
  job_list_card_view: boolean;
  config: IUserPrefConfigData;
  sms_number: IPhoneNumberData;
  storm_monitoring: any;
}

export interface IUserPreferenceRecord {
  id: number;
  user_id: number;
  estimator_tour: boolean;
  created_at: Date;
  updated_at: Date;
  job_list_card_view: boolean;
  config: IUserPrefConfigRecord;
  sms_number: PhoneNumberRecord;
  storm_monitoring: any;
}

// Default Properties

const defaultUserPreferenceProps: IUserPreferenceRecord = {
  id: 0,
  user_id: 0,
  estimator_tour: false,
  created_at: new Date(),
  updated_at: new Date(),
  job_list_card_view: false,
  config: userPrefConfigFromJSON({ notifications: {} as INotificationsConfigData }),
  sms_number: phoneFromJSON({}),
  storm_monitoring: {},
};

export class UserPreferenceRecord extends Record(defaultUserPreferenceProps) implements IUserPreferenceRecord {}
